export function normalizeContactPhone(value: string): string | null {
  const digits = value.replace(/\D/g, "");
  if (digits.length < 8 || digits.length > 15 || digits.startsWith("0")) {
    return null;
  }

  return `+${digits}`;
}
